
const AccountFormPlaceholder = () => {

    jQuery(document).on('reset', '#account_form', function(e) {
        e.preventDefault();
    });

    document.addEventListener("DOMContentLoaded", function() {
        const first_name          = document.querySelector('input[name="first_name"]');
        const last_name           = document.querySelector('input[name="last_name"]');
        const user_patronymic     = document.querySelector('input[name="user_patronymic"]');
        const user_lat_first_name = document.querySelector('input[name="user_lat_first_name"]');
        const user_lat_last_name  = document.querySelector('input[name="user_lat_last_name"]');
        const user_date_of_birth  = document.querySelector('input[name="user_date_of_birth"]');
        const user_tel            = document.querySelector('input[name="user_tel"]');
        const user_email            = document.querySelector('input[name="user_email"]');

        if(first_name){
            first_name.setAttribute('placeholder', rcTranslate.first_name);
        }
        if(last_name){
            last_name.setAttribute('placeholder', rcTranslate.last_name);
        }
        if(user_patronymic){
            user_patronymic.setAttribute('placeholder', rcTranslate.user_patronymic);
        }
        if(user_lat_first_name){
            user_lat_first_name.setAttribute('placeholder', rcTranslate.first_name);
        }
        if(user_lat_last_name){
            user_lat_last_name.setAttribute('placeholder', rcTranslate.last_name);
        }
        if(user_date_of_birth){
            user_date_of_birth.setAttribute('placeholder', rcTranslate.user_date_of_birth);
        }
        if(user_tel){
            user_tel.setAttribute('placeholder', rcTranslate.user_tel);
        }
        if(user_email){
            user_email.setAttribute('placeholder', rcTranslate.user_email);
        }
    });

};

export default AccountFormPlaceholder;
